export default __webpack_public_path__ + "static/media/back.c791237a.svg";